// extracted by mini-css-extract-plugin
export default {"contact-info":"Footer_contact-info__xCpmc","quick-links":"Footer_quick-links__zSef+","legal":"Footer_legal__fy6ps"};